import React, { useState, useEffect } from "react";
import { useHistory, useParams, Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useToasts } from "react-toast-notifications";
import { useQuery } from "react-query";
import { baseUrl } from "utils/api";
import Spinner from "components/Spinner/Spinner";
import axios from "axios";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import EditImage from "./EditImageItem";
import AddImage from "./AddImageItem";

import {
  fetchStockCategories,
  fetchStockClasses,
  fetchSuppliers,
  fetchStoreLocations,
  fetchStores,
  fetchLevies,
  fetchUnits,
} from "services/fetchData";

import { addNewStockItem, updateNewStockItem } from "services/createServices";

// firebase
import { storage } from "services/firebase";

export default function EditStockItem() {
  const { addToast } = useToasts();
  let { id } = useParams();
  let history = useHistory();
  const token = localStorage.getItem("token");
  const [item, setItem] = useState({});
  const [url, setUrl] = useState();
  const [err, setErr] = useState({});
  const [image, setImage] = useState();
  const [loading, setLoading] = useState(true);
  const [changeImage, setChangeImage] = useState(false);
  const [currentImage, setCurrentImage] = useState();
  const { data: categories } = useQuery("categories", fetchStockCategories);

  const { data: classes } = useQuery("classes", fetchStockClasses);

  const { data: suppliers } = useQuery("suppliers", fetchSuppliers);

  const { data: stores } = useQuery("stores", fetchStores);

  const { data: storeLocations } = useQuery(
    "storeLocations",
    fetchStoreLocations
  );

  const { data: leviesData } = useQuery("levies", fetchLevies);

  const { data: unitsData } = useQuery("units", fetchUnits);

  const getStockItem = async () => {
    var config = {
      method: "get",
      url: `http://134.209.28.149:8080/stocks/${id}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    await axios(config)
      .then(function (response) {
        setItem(response.data);
        console.log(response.data);
        if (response.data.image_url) {
          setCurrentImage(response.data.image_url);
        }
        setTimeout(() => {
          setLoading(false);
        }, 3000);
      })
      .catch(function (error) {
        return error;
      });
  };

  const editStockItem = async () => {
    var config = {
      method: "put",
      url: `${baseUrl}stocks`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: item,
    };

    await axios(config)
      .then(function (response) {
        console.log(response);
        history.push("/admin/file-maintainance/stock-items");

        addToast("Successfully editstock item", {
          appearance: "success",
          autoDismiss: true,
        });
      })
      .catch(function (error) {
        addToast("Successfully create new stock item", {
          appearance: "success",
          autoDismiss: true,
        });
        return error;
      });
  };

  useEffect(() => {
    getStockItem();
  }, []);

  useEffect(() => {
    if (url) {
      editStockItem();
    }
  }, [url]);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setItem({ ...item, [name]: value });
  };

  const deleteImage = async () => {
    let imageRef = storage.refFromURL(currentImage);
    await imageRef
      .delete()
      .then(() => {
        // File deleted successfully
        addToast("Successfully delete image", {
          appearance: "success",
          autoDismiss: true,
        });
      })
      .catch((error) => {
        addToast(`${error.message}`, {
          appearance: "error",
          autoDismiss: true,
        });
      });
  };

  const uploadPicture = async () => {
    const uploadTask = storage.ref(`images/${image[0].name}`).put(image[0]);

    await uploadTask.on(
      "state_changed",
      (snapshot) => {},
      (error) => {
        throw error;
      },
      () => {
        storage
          .ref("images")
          .child(image[0].name)
          .getDownloadURL()
          .then((url) => {
            let stockImagez = [
              {
                itemId: "8394a07c-a17f-4fea-9ee5-867bdab0d622",
                code: item.code,
                image_url: url,
                color: item.color,
                c_sel: 0,
              },
            ];
            setItem({
              ...item,
              stockImagez,
              image_url: url,
            });
            setUrl(url);
          });
      }
    );
  };

  const handleValidation = () => {
    let formIsValid = true;
    let errors = {};
    if (!item.code) {
      errors.code = "Item Code Cannot be empty";
      formIsValid = false;
    }
    if (!item.name) {
      errors.name = "Item Name Cannot be empty";
      formIsValid = false;
    }
    if (!item.category) {
      errors.category = "ITem Category Cannot empty";
      formIsValid = false;
    }
    if (!item.supplier) {
      errors.supplier = "Item Supplier Cannot empty";
      formIsValid = false;
    }
    if (!item.store) {
      errors.store = "Item Store Cannot empty";
      formIsValid = false;
    }
    if (!item.location) {
      errors.location = "ITem Location Cannot empty";
      formIsValid = false;
    }
    if (!item.description) {
      errors.description = "Item Description Cannot empty";
      formIsValid = false;
    }
    if (!item.clasz) {
      errors.clasz = "Item Class Cannot empty";
      formIsValid = false;
    }

    if (!item.frezze) {
      errors.frezze = "Item Frezze Cannot empty";
      formIsValid = false;
    }
    if (!item.levy_1) {
      errors.levy_1 = "Item Levy Cannot empty";
      formIsValid = false;
    }
    if (!item.price_1) {
      errors.price_1 = "Item Price Cannot empty";
      formIsValid = false;
    }
    if (!item.min_price) {
      errors.min_price = "Item Minimum price Cannot empty";
      formIsValid = false;
    }
    if (!item.cost_price) {
      errors.cost_price = "Item Cost Price Cannot empty";
      formIsValid = false;
    }

    if (!image && !item.image_url) {
      errors.image = "Image field cannot be empty";
      formIsValid = false;
    }

    setErr(errors);
    console.log(err);
    return formIsValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // check validation
    if (handleValidation()) {
      // check imageChange
      if (changeImage) {
        await deleteImage();
      }

      // upload new image
      if (image) {
        return await uploadPicture();
      }

      await editStockItem();
    } else {
      addToast("Missing fields", {
        appearance: "error",
        autoDismiss: true,
      });
    }
  };

  return (
    <>
      <div
        className="relative  min-w-0 break-words w-full  bg-gray-200 border-0"
        style={{ paddingTop: "4rem" }}
      >
        <div
          className="flex flex-col shadow-lg rounded-lg mb-6"
          style={{ margin: "3rem" }}
        >
          <div className="rounded-t bg-white mb-0 px-6 py-6">
            <div className="">
              <h6 className="text-gray-800 text-xl font-bold">
                Edit Stock Item
              </h6>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "1rem",
                }}
              >
                <Link
                  to="/admin/dashboard"
                  className="text-sm hover:text-gray-200 lg:inline-block font-semibold"
                  style={{ color: "#6e7581" }}
                >
                  DASHBOARD
                </Link>
                <ArrowForwardIosIcon
                  style={{
                    color: "#6e7581",
                    fontSize: "12px",
                    margin: "0 1rem",
                  }}
                />
                <Link
                  to="/admin/file-maintainance"
                  className=" text-sm hover:text-gray-200 lg:inline-block font-semibold"
                  style={{ color: "#6e7581" }}
                >
                  FILE MAINTAINANCE
                </Link>
                <ArrowForwardIosIcon
                  style={{
                    color: "#6e7581",
                    fontSize: "12px",
                    margin: "0 1rem",
                  }}
                />
                <Link
                  to="/admin/file-maintainance/stock-items"
                  className=" text-sm hover:text-gray-200 lg:inline-block font-semibold"
                  style={{ color: "#6e7581" }}
                >
                  STOCK ITEMS
                </Link>
                <ArrowForwardIosIcon
                  style={{
                    color: "#6e7581",
                    fontSize: "12px",
                    margin: "0 1rem",
                  }}
                />
                <span
                  className="text-sm uppercase hidden lg:inline-block font-semibold"
                  style={{ color: "rgb(194 216 234)" }}
                >
                  EDIT STOCK ITEM
                </span>
              </div>
            </div>
          </div>
          <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
            <form>
              <h6 className="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">
                Item Details
              </h6>
              <div className="flex flex-wrap">
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="code"
                    >
                      Item Code
                    </label>
                    <input
                      type="text"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      name="code"
                      value={item.code}
                      placeholder="code"
                      onChange={handleChange}
                    />
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {err.code}
                    </span>
                  </div>
                </div>
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="name"
                    >
                      Item Name
                    </label>
                    <input
                      type="text"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      placeholder="name"
                      value={item.name}
                      name="name"
                      onChange={handleChange}
                    />
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {err.name}
                    </span>
                  </div>
                </div>
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="category"
                    >
                      Category
                    </label>
                    <select
                      type="text"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      name="category"
                      onChange={handleChange}
                    >
                      <option value="">Select Category...</option>
                      {categories?.map((el, i) =>
                        el.id === item.category ? (
                          <option value={el.id} key={i} selected="selected">
                            {el.name}
                          </option>
                        ) : (
                          <option value={el.id} key={i}>
                            {el.name}
                          </option>
                        )
                      )}
                    </select>
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {err.category}
                    </span>
                  </div>
                </div>
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="supplier"
                    >
                      Supplier
                    </label>
                    <select
                      type="text"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      name="supplier"
                      onChange={handleChange}
                    >
                      <option value="">Select Supplier...</option>
                      {suppliers?.map((el, i) =>
                        el.id === item.supplier ? (
                          <option value={el.id} key={i} selected="selected">
                            {el.name}
                          </option>
                        ) : (
                          <option value={el.id} key={i}>
                            {el.name}
                          </option>
                        )
                      )}
                    </select>
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {err.supplier}
                    </span>
                  </div>
                </div>
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="store"
                    >
                      Store
                    </label>
                    <select
                      type="text"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      name="store"
                      onChange={handleChange}
                    >
                      <option value="">Select Store...</option>
                      {stores?.map((el, i) =>
                        el.id === item.store ? (
                          <option value={el.id} key={i} selected="selected">
                            {el.name}
                          </option>
                        ) : (
                          <option value={el.id} key={i}>
                            {el.name}
                          </option>
                        )
                      )}
                    </select>
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {err.store}
                    </span>
                  </div>
                </div>
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="location"
                    >
                      Store Location
                    </label>
                    <select
                      type="text"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      name="location"
                      onChange={handleChange}
                    >
                      <option value="">Select Location...</option>
                      {storeLocations?.map((el, i) =>
                        el.id === item.location ? (
                          <option value={el.id} key={i} selected="selected">
                            {el.name}
                          </option>
                        ) : (
                          <option value={el.id} key={i}>
                            {el.name}
                          </option>
                        )
                      )}
                    </select>
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {err.location}
                    </span>
                  </div>
                </div>
              </div>

              <hr className="mt-6 border-b-1 border-gray-400" />

              <h6 className="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">
                Description
              </h6>
              <div className="flex flex-wrap">
                <div className="w-full lg:w-12/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="description"
                    >
                      Description
                    </label>
                    <textarea
                      type="text"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      rows="4"
                      value={item.description}
                      name="description"
                      onChange={handleChange}
                    ></textarea>
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {err.description}
                    </span>
                  </div>
                </div>
                <div className="w-full lg:w-4/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="clasz"
                    >
                      Class
                    </label>
                    <select
                      type="text"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      name="clasz"
                      onChange={handleChange}
                    >
                      <option value="">Select Class...</option>
                      {classes?.map((el, i) =>
                        el.id === item.clasz ? (
                          <option value={el.id} key={i} selected="selected">
                            {el.name}
                          </option>
                        ) : (
                          <option value={el.id} key={i}>
                            {el.name}
                          </option>
                        )
                      )}
                    </select>
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {err.clasz}
                    </span>
                  </div>
                </div>
                <div className="w-full lg:w-4/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="units_1"
                    >
                      Units
                    </label>
                    <select
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      name="units_1"
                      onChange={handleChange}
                    >
                      <option value="">Select Units...</option>
                      {unitsData?.map((el, i) =>
                        el.id === item.units_1 ? (
                          <option value={el.id} key={i} selected="selected">
                            {el.name}
                          </option>
                        ) : (
                          <option value={el.id} key={i}>
                            {el.name}
                          </option>
                        )
                      )}
                    </select>
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {err.units_1}
                    </span>
                  </div>
                </div>
                <div className="w-full lg:w-4/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="pack_1"
                    >
                      Pack
                    </label>
                    <input
                      type="number"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      placeholder="pack"
                      name="pack_1"
                      value={item.pack_1}
                      onChange={handleChange}
                    />
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {err.pack_1}
                    </span>
                  </div>
                </div>

                <div className="w-full lg:w-4/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="weight"
                    >
                      Weight
                    </label>
                    <input
                      type="number"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      placeholder="weight"
                      value={item.weight}
                      name="weight"
                      onChange={handleChange}
                    />
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {err.weight}
                    </span>
                  </div>
                </div>
                <div className="w-full lg:w-4/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="ord_lvl"
                    >
                      Order Level
                    </label>
                    <input
                      type="number"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      placeholder="order level"
                      value={item.ord_lvl}
                      name="ord_lvl"
                      onChange={handleChange}
                    />
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {err.ord_lvl}
                    </span>
                  </div>
                </div>
                <div className="w-full lg:w-4/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="leadtime"
                    >
                      Lead Time
                    </label>
                    <input
                      type="number"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      placeholder="leadtime"
                      value={item.leadtime}
                      name="leadtime"
                      onChange={handleChange}
                    />
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {err.leadtime}
                    </span>
                  </div>
                </div>
                <div className="w-full lg:w-4/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="frezze"
                    >
                      Freeze
                    </label>
                    <select
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      name="frezze"
                      onChange={handleChange}
                    >
                      {["Default", "Stock Out", "Suspend"].map((el, i) =>
                        i == item.frezze ? (
                          <option value={i} key={i} selected="selected">
                            {el}
                          </option>
                        ) : (
                          <option value={i} key={i}>
                            {el}
                          </option>
                        )
                      )}
                    </select>
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {err.frezze}
                    </span>
                  </div>
                </div>
                <div className="w-full lg:w-4/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="levy_1"
                    >
                      Levies
                    </label>
                    <select
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      name="levy_1"
                      onChange={handleChange}
                    >
                      <option value="">Select Levy...</option>
                      {leviesData?.map((el, i) =>
                        el.id === item.levy_1 ? (
                          <option value={el.id} key={i} selected="selected">
                            {el.name}
                          </option>
                        ) : (
                          <option value={el.id} key={i}>
                            {el.name}
                          </option>
                        )
                      )}
                    </select>
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {err.levy_1}
                    </span>
                  </div>
                </div>
              </div>

              <hr className="mt-6 border-b-1 border-gray-400" />
              <h6 className="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">
                Pricing Details
              </h6>
              <div className="flex flex-wrap">
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="price_1"
                    >
                      Price
                    </label>
                    <input
                      type="number"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      name="price_1"
                      value={item.price_1}
                      placeholder="price"
                      onChange={handleChange}
                    />
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {err.price_1}
                    </span>
                  </div>
                </div>
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="min_price"
                    >
                      Minimum price
                    </label>
                    <input
                      type="number"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      name="min_price"
                      value={item.min_price}
                      placeholder="min price"
                      onChange={handleChange}
                    />
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {err.min_price}
                    </span>
                  </div>
                </div>
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="cost_price"
                    >
                      Cost Price
                    </label>
                    <input
                      type="text"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      name="cost_price"
                      value={item.cost_price}
                      placeholder="cost price"
                      onChange={handleChange}
                    />
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {err.cost_price}
                    </span>
                  </div>
                </div>
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="avwcost"
                    >
                      Average Price
                    </label>
                    <input
                      type="text"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      name="avwcost"
                      value={item.avwcost}
                      placeholder="average price"
                      onChange={handleChange}
                    />
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {err.avwcost}
                    </span>
                  </div>
                </div>
              </div>
              <hr className="mt-6 border-b-1 border-gray-400" />

              <h4 className="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">
                Stock Item Image
              </h4>
              <div className="flex flex-wrap">
                <div className="w-full lg:w-12/12 px-4">
                  <div className="relative w-full mb-3">
                    {!loading ? (
                      item.image_url ? (
                        <EditImage
                          imageUrl={item.image_url}
                          setChangeImage={setChangeImage}
                          item={item}
                          setItem={setItem}
                        />
                      ) : image ? (
                        <span>Image Selected</span>
                      ) : (
                        <AddImage setImage={setImage} />
                      )
                    ) : (
                      <div className="loading_spinner">
                        <Spinner />
                      </div>
                    )}
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {err.image}
                    </span>
                  </div>
                </div>
                <div className="w-full lg:w-12/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="color"
                    >
                      Color
                    </label>
                    <input
                      type="text"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      placeholder="color"
                      name="color"
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="text-center flex justify-between">
                  <button
                    className="bg-blue-500 text-white active:bg-blue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                    type="button"
                    style={{
                      marginTop: "2rem",
                    }}
                    onClick={handleSubmit}
                  >
                    Edit Item
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
